module.exports = __webpack_public_path__ + "img/banner_1.7d4e8206.svg";